import { render, staticRenderFns } from "./AditionalsPage.vue?vue&type=template&id=6657481e&scoped=true"
import script from "./AditionalsPage.vue?vue&type=script&lang=js"
export * from "./AditionalsPage.vue?vue&type=script&lang=js"
import style0 from "./AditionalsPage.vue?vue&type=style&index=0&id=6657481e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6657481e",
  null
  
)

export default component.exports